import { IconChevronLeft, IconX } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import { useState } from "react";
import InputField from "../../../components/common/InputField";
import { useMerchantAllListData } from "../../../apis/merchantApis";

const receivers = [
  { name: "Ramesh Kumar", img: "/img/dummy-driver.png", assigned: true },
  { name: "Suresh Kumar", img: "/img/dummy-driver.png", assigned: false },
  { name: "Kalesh Kumar", img: "/img/dummy-driver.png", assigned: true },
  { name: "Paresh Kumar", img: "/img/dummy-driver.png", assigned: false },
  { name: "Ramesh Kumar", img: "/img/dummy-driver.png", assigned: true },
  { name: "Suresh Kumar", img: "/img/dummy-driver.png", assigned: false },
  { name: "Kalesh Kumar", img: "/img/dummy-driver.png", assigned: true },
  { name: "Paresh Kumar", img: "/img/dummy-driver.png", assigned: false },
  { name: "Ramesh Kumar", img: "/img/dummy-driver.png", assigned: true },
  { name: "Suresh Kumar", img: "/img/dummy-driver.png", assigned: false },
  { name: "Kalesh Kumar", img: "/img/dummy-driver.png", assigned: true },
  { name: "Paresh Kumar", img: "/img/dummy-driver.png", assigned: false },
];

type SwapDriverModalProps = {
  open: boolean;
  onClose: () => void;
};

const ViewConnectClientModal = ({ open, onClose }: SwapDriverModalProps) => {
  const { data: clients } = useMerchantAllListData();

  console.log(clients, "clients...........");

  const [view, setView] = useState(false);
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-[#F7F6F2] rounded-3xl w-[32rem] ">
        {/* Header */}
        {view ? (
          <div className="flex items-center gap-3 p-4 border-b">
            <button
              onClick={() => setView(false)}
              className="p-1.5 border border-gray-300 rounded-full hover:bg-gray-100 transition"
            >
              <IconChevronLeft strokeWidth={1.5} size={22} />
            </button>
            <h1 className="text-lg font-medium">Client Name (Shopify)</h1>
          </div>
        ) : (
          <div className="flex items-center justify-between px-4 py-3 border-b">
            <div>
              <h2 className="text-lg font-medium text-[#212121]">
                Connected Clients Shopify
              </h2>
              <p className="text-sm text-gray-600">
                To view connected credentials, click the View button{" "}
              </p>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-full border border-[#D2D2D2]"
            >
              <IconX size={20} />
            </button>
          </div>
        )}
        {view ? (
          <div>
            <div className="p-4 space-y-4">
              <InputField
                label="Shopify Store URL"
                type="text"
                placeholder="https://yourstore.myshopify.com"
                value="https://yourstore.myshopify.com"
              />
              <InputField
                label="Shopify Store URL"
                type="text"
                placeholder="https://yourstore.myshopify.com"
                value="https://yourstore.myshopify.com"
              />
              <InputField
                label="Shopify Store URL"
                type="text"
                placeholder="https://yourstore.myshopify.com"
                value="https://yourstore.myshopify.com"
              />
            </div>
          </div>
        ) : (
          <div className="flex-1 w-[500px] h-[53vh] flex flex-col overflow-hidden">
            {/* Search */}
            <div className="px-4 py-2">
              <NormalSearch className="w-full" value="" onChange={() => {}} />
            </div>

            {/* Receivers List */}
            <div className="flex-1 overflow-y-auto hide-scrollbar px-4 py-2 space-y-2">
              {clients.map((item: any, index: any) => (
                <div
                  key={index}
                  className="flex items-center py-1 justify-between"
                >
                  <div className="flex items-center gap-2">
                    <img
                      src={item.companyLogo || "/img/dummy-driver.png"}
                      className="w-10 h-10 rounded-full"
                      alt=""
                    />
                    <p className="text-[#000000] text-base font-normal">
                      {item.name}
                    </p>
                  </div>
                  <button
                    onClick={() => setView(true)}
                    className="px-4 py-1 text-sm rounded-full border border-[#007AFF] text-[#007AFF] hover:bg-[#007AFF]/10"
                  >
                    View
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewConnectClientModal;
